/** Short human-readable template label the user will recognise
 *  (``doc`` / ``deck`` / ``quote`` / ``arch`` / ``release``), with
 *  a generic ``.replace`` fallback for any future template slug.
 *  Lives next to `documentIcon.tsx` so the library list + reference
 *  picker keep the same vocabulary; slugs like ``default-v1``
 *  are internal. Legacy ``appli-*-v1`` slugs (stored on older
 *  document rows) still resolve via the alias checks + fallback.
 *  Kept as a separate file so `documentIcon.tsx` only
 *  exports components — that keeps Vite Fast Refresh happy. */
export function templateLabel(slug: string): string {
  if (slug === "default-v1" || slug === "appli-default-v1") return "doc";
  if (slug === "presentation-v1" || slug === "appli-presentation-v1")
    return "deck";
  if (slug === "quotation-v1" || slug === "appli-quotation-v1") return "quote";
  if (slug === "architecture-v1" || slug === "appli-architecture-v1")
    return "arch";
  if (slug === "release-notes-v1" || slug === "appli-release-notes-v1")
    return "release";
  return slug.replace(/^appli-|-v\d+$/g, "").replace(/-v\d+$/, "");
}
